export default "__VITE_ASSET__CRCKvKcG__"